'use strict';

var utils = require('@fivethirtyeight/interactive-utils');
var _ = require('underscore'); 

// Put your project specific utility functions here
module.exports = _.extend(utils, {

  getTotalLimits: function(data) {
    var limits = [],
      min,
      max;

    min = _.min(data.objects.counties.geometries, function(county){
      return county.properties.total;
    }).properties.total;

    max = _.max(data.objects.counties.geometries, function(county){
      return county.properties.total;
    }).properties.total;

    limits.push(Math.log(min));
    limits.push(Math.log(max));

    return limits;
  },


  getCandLimits: function(data, candidate) {
    
    var limits = [],
      min,
      max;

    var cand_data = [];

    _.each(data.objects.counties.geometries, function(county){

      var chosen = _.filter(county.properties.fb, function(cand){
        return cand.name === candidate;
      })[0];

      cand_data.push(chosen.val);
    })

    min = _.min(cand_data);
    max = _.max(cand_data);

    limits.push(min);
    limits.push(max);

    return limits;
  },

  fullName: {

   'bush': 'Jeb Bush',
   'carson': 'Ben Carson',
   'christie': 'Chris Christie',
   'cruz': 'Ted Cruz',
   'fiorina': 'Carly Fiorina',
   'gilmore': 'Jim Gilmore',
   'huckabee': 'Mike Huckabee',
   'kasich': 'John Kasich',
   'paul': 'Rand Paul',
   'rubio': 'Marco Rubio',
   'santorum': 'Rick Santorum',
   'trump': 'Donald Trump',
   'webb': 'Jim Webb'

  },

  candidate_colors: {
    'bush': '#f781bf',
    'carson': '#60BD68',
    'christie': '#B276B2',
    'cruz': '#5DA5DA',
    'fiorina': '#810f7c',
    'gilmore': '#984ea3',
    'graham': '#a65628',
    'huckabee': '#999999',
    'kasich': '#4daf4a',
    'paul': '#000000',
    'rubio': '#F15854',
    'santorum': '#b2b2b2',
    'trump': '#FAA43A',
    'webb': '#ffff33',
    'blank': '#ffffff'
  },

  formatPercent: function(val) {
    if(val > 99) {
      return '>99%';
    }
    else if(val < 1) {
      return '<1%';
    }
    else {
      return this.fixedRound(val,0) + '%';
    }
    
  },

  activeCandidate: function(candidate, selected) {
    return selected.indexOf(candidate) > -1 ? 'selected' : 'unselected';
  },

  getDiff: function(candidate, value, us_data) {
    var us_val = _.filter(us_data, function(cand){return cand.name === candidate})[0].val;
    var value = this.fixedRound(value - us_val, 0);
    if (value > 0){
      return '+' + value;
    }
    else if(value == 0) {
      return '–';
    }
    else {
      return value;
    }
  }
  
});
